// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-btn[data-v-3adba97c]{background-color:transparent!important;border:none!important;color:#7a7f89!important}.delete-btn[data-v-3adba97c]:hover,.delete-btn span[data-v-3adba97c]:hover{background-color:transparent!important;color:#ea2d2d!important}", ""]);
// Exports
module.exports = exports;
